import baseFetch, { createParamString } from '../baseFetch';
import { findMeterFromArguments, getMeterParamsForRequest } from '../../utils/meteringHelper';

export const fetchWaveForecast = (
  spotId,
  days,
  intervalHours,
  maxHeights = false,
  corrected,
  ...rest
) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/wave?${createParamString({
      spotId,
      days,
      intervalHours,
      maxHeights,
      meterRemaining,
      corrected,
    })}`,
    {
      headers: {
        ...meterHeaders,
      },
    },
  );
};

export const fetchTideForecast = (
  spotId,
  days,
  intervalHours,
  _,
  corrected,
  sharedTideService = false,
  ...rest
) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/tides?${createParamString({
      spotId,
      days,
      meterRemaining,
      sharedTideService,
    })}`,
    {
      headers: {
        ...meterHeaders,
      },
    },
  );
};

export const fetchWeatherForecast = (spotId, days, intervalHours, _, corrected, ...rest) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/weather?${createParamString({
      spotId,
      days,
      intervalHours,
      meterRemaining,
      corrected,
    })}`,
    {
      headers: {
        ...meterHeaders,
      },
    },
  );
};

export const fetchWindForecast = (spotId, days, intervalHours, _, corrected, ...rest) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/wind?${createParamString({
      spotId,
      days,
      intervalHours,
      meterRemaining,
      corrected,
    })}`,
    {
      headers: {
        ...meterHeaders,
      },
    },
  );
};

export const fetchRegionalConditionForecast = (subregionId, days, _1, _2, corrected, ...rest) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/regions/forecasts/conditions?${createParamString({
      subregionId,
      days,
      meterRemaining,
      corrected,
    })}`,
    {
      headers: {
        ...meterHeaders,
      },
    },
  );
};

export const fetchRegionalWaveForecast = (
  subregionId,
  days,
  intervalHours,
  maxHeights = false,
  corrected,
  ...rest
) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/regions/forecasts/wave?${createParamString({
      subregionId,
      days,
      intervalHours,
      maxHeights,
      meterRemaining,
      corrected,
    })}`,
    {
      headers: {
        ...meterHeaders,
      },
    },
  );
};

export const fetchTaxononmySwellEvents = (id, type, meter) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(`/kbyg/events/taxonomy?${createParamString({ id, type, meterRemaining })}`, {
    headers: {
      ...meterHeaders,
    },
  });
};
